import React from 'react';
import { COLORS } from '@constants';
import { Button, Icon, Typography } from '@ui';
import { Flex } from 'antd';
import { StyledThemeAlert } from './styled';

const THEME_EXTENSION_CONNECTED = 'CONNECTED';

const ThemeExtensionStatus = ({ themeExtension, isValid }) => {
    if (!themeExtension || !isValid) {
        return null;
    }

    const isConnected = themeExtension.status === THEME_EXTENSION_CONNECTED;
    const enableUrl = themeExtension.enableUrl;

    if (isConnected) {
        return null;
    }

    return (
        <StyledThemeAlert $isConnected={false} data-e2e='integrations_theme-extension-not-connected_block'>
            <Flex justify='space-between' align='center'>
                <Flex align='center' gap={8}>
                    <Icon.CloseCircleIcon color={COLORS.$tartRed} />
                    <Typography.Text color={COLORS.$tartRed} type='descriptor1'>
                        Activate Klickly
                    </Typography.Text>
                </Flex>
                {enableUrl && (
                    <Button type='primary' style={{ width: 200 }} onClick={() => window.open(enableUrl, '_blank')}>
                        Activate
                    </Button>
                )}
            </Flex>
        </StyledThemeAlert>
    );
};

export default ThemeExtensionStatus;
